
<template>
  <div>
    <!-- <vs-popup class="holamundo" popup-class="w-9/12" :title="title" :active.sync="popupActive"> -->

    <vx-card class="mb-2">
      <vs-table id="tbl2" ref="tbl2" :data="items" class="table-dark-inverted">
        <template slot="header">
          <div class="vx-row mb-2 w-full">
            <div class="vx-col sm:w-2/3 flex-inline">
              <div class="vx-row mb-2">
                <div class="vx-col">
                  <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-button
                      class="mr-3 mb-2"
                      @click="$router.go(-1)"
                      type="flat"
                      icon-pack="feather"
                      icon="icon-chevron-right"
                      >بازگشت</vs-button
                    >
                  </div>
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col">
                  <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    تنظیمات قالب "{{ $route.query.GroupName }}"
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-col sm:w-1/3 flex-inline">
              <vs-button
                style="float: left"
                @click="new_()"
                class="mx-3"
                color="dark"
                type="border"
                icon-pack="feather"
                icon="icon-plus"
                >جدید</vs-button
              >
            </div>
          </div>
        </template>
        <template slot="thead">
          <vs-th>ردیف</vs-th>
          <vs-th>نام </vs-th>
          <vs-th>enum </vs-th>
          <vs-th>مقدار</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <span>{{ indextr + 1 }}</span>
            </vs-td>
            <vs-td>
              <vs-chip color="primary">{{
                CustomSettingName[tr.name].title
              }}</vs-chip>
            </vs-td>
            <vs-td>
              <vs-chip color="dark">{{
                CustomSettingName[tr.name].name
              }}</vs-chip>
            </vs-td>
            <vs-td>
              <vs-chip color="rgb(62, 201, 214)">{{ tr.value }}</vs-chip>
            </vs-td>
            <vs-td>
              <vs-dropdown>
                <a class="flex items-center" href.prevent>
                  عملیات
                  <i class="material-icons">expand_more</i>
                </a>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="edit(tr.id, tr.name)"
                    >ویرایش</vs-dropdown-item
                  >
                  <vs-dropdown-item @click="confirmDelete(tr.id, tr.name)"
                    >حذف</vs-dropdown-item
                  >
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <!-- </vs-popup> -->
    <edit-custom-setting
      ref="editCustomSetting1"
      @success="fillTable"
    ></edit-custom-setting>
    <create-custom-setting
      ref="createCustomSetting1"
      @success="fillTable"
    ></create-custom-setting>
  </div>
</template>
<style>
</style>
<script>
import { CreateEditMode, CustomSettingName, CommissionType } from "@/enums.js";
import EditCustomSetting from "./EditCustomSetting.vue";
import CreateCustomSetting from "./CreateCustomSetting.vue";
export default {
  name: "commissions",
  props: {},
  components: { EditCustomSetting,CreateCustomSetting },
  data() {
    return {
      CustomSettingName,
      CommissionType,
      popupActive: false,
      createEditMode: CreateEditMode.Create,
      title: "",
      items: [],
    };
  },
  methods: {
    fillTable() {
      let loading = this.$vs.loading();
      let payload = {
        params: {
          id: this.$route.query.GroupId,
        },
      };
      this.$http
        .get("/api/services/app/customSetting/GetCustomSettings", payload)
        .then((response) => {
          this.items = response.data.result;
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    new_() {
      this.$refs.createCustomSetting1.show(this.$route.query.GroupId);
    },
    confirmDelete(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `تاییدیه حذف`,
        text: `آیا از حذف ‌کارمزد "${this.CustomSettingName[name].title}" مطمئن هستید؟`,
        accept: () => {
          this.delete_(id);
        },
        acceptText: "تایید",
        cancelText: "انصراف",
      });
    },
    delete_(id) {
      let loading = this.$vs.loading();
      let payload = {
        params: {
          id: id,
        },
      };
      this.$http
        .delete("/api/services/app/customSetting/Delete", payload)
        .then((response) => {
          if (response.data.success == true) {
            this.fillTable();
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "کارمزد با موفقیت حذف شد",
            });
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    edit(id, name) {
      this.$refs.editCustomSetting1.show(id, name);
    },
  },
  mounted() {
    this.fillTable();
  },
};
</script>